export const lengthRequirement = "Must be at least 6 characters long\n";
export const specialCharRequirement = "Must contain at least one special character\n";
export const numberRequirement = "Must contain at least one number\n";
export const excludedWordsRequirement = 'Can not contain any words that are excluded (e.g."dynamed", "ebsco", "ehost", "admin", "password", "pa$$word", "p@$$", "pa$$", "p@ss")';

export const requirements = lengthRequirement + specialCharRequirement + numberRequirement + excludedWordsRequirement;